import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Filter, { FilterModel } from '../../components/Filter/Filter';
import { upsertFilterToKey } from '../../services/filterService';

export class CustomerFilterFields extends FilterModel {
  constructor(data: any = {}) {
    super(data);
  }

  public get totalFilters(): number {
    let total = 0;
    if (this.q) total += 1;
    return total;
  }
}

interface CustomersFilterProps {
  onSubmit: (data: CustomerFilterFields) => void;
  filterFields: CustomerFilterFields;
}

export default function CustomersFilter({
  onSubmit,
  filterFields,
}: CustomersFilterProps) {
  const { register, handleSubmit, reset } = useForm<CustomerFilterFields>({
    mode: 'onBlur',
  });
  const pageKey = 'customers';

  const [customersLoading, setCustomersLoading] = useState(false);

  const clear = () => {
    reset({
      q: null,
      skip: 0,
      take: 25,
    });
    upsertFilterToKey(pageKey, {});
  };

  useEffect(() => {
    reset(filterFields);
  }, [filterFields]);

  return (
    <Filter
      isLoading={customersLoading}
      onSubmit={handleSubmit(onSubmit)}
      clear={clear}
      totalApplied={filterFields?.totalFilters || 0}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <input
            {...register('q')}
            className='form-control'
            placeholder='Digite para pesquisar'
            type='text'
          />
        </div>
      </form>
    </Filter>
  );
}
